import { Chip } from "primereact/chip";
import S from "./TagBrowser.module.scss";
import { languageDisplayNames, technologyDisplayNames } from "sj-ui-toolkit/src/constants";

const TagBrowser = ({
  technologies = [],
  languages = [],
  onTechnologySelect,
  onLanguageSelect,
  selectedTechnologies = [],
  selectedLanguages = [],
}) => {
  const handleTechClick = tech => {
    if (onTechnologySelect) {
      onTechnologySelect(tech);
    }
  };

  const handleLangClick = lang => {
    if (onLanguageSelect) {
      onLanguageSelect(lang);
    }
  };

  const handleKeyDown = (e, callback) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      callback();
    }
  };

  const isTechSelected = tech => selectedTechnologies.includes(tech);
  const isLangSelected = lang => selectedLanguages.includes(lang);

  return (
    <div className={S.tagBrowser}>
      <h2 className="sr-only">Browse by Topic</h2>
      <section className={S.tagSection}>
        <h3 className={S.sectionTitle}>Browse by Technology</h3>
        <div className={S.tagList} role="group" aria-label="Technology filters">
          {technologies.map(tech => {
            const selected = isTechSelected(tech);
            return (
              <Chip
                key={tech}
                label={technologyDisplayNames[tech] || tech}
                className={`${S.tagChip} ${selected ? S.selected : ""}`}
                role="switch"
                aria-checked={selected}
                tabIndex={0}
                onClick={() => handleTechClick(tech)}
                onKeyDown={e => handleKeyDown(e, () => handleTechClick(tech))}
              />
            );
          })}
        </div>
      </section>

      <section className={S.tagSection}>
        <h3 className={S.sectionTitle}>Browse by Language</h3>
        <div className={S.tagList} role="group" aria-label="Language filters">
          {languages.map(lang => {
            const selected = isLangSelected(lang);
            return (
              <Chip
                key={lang}
                label={languageDisplayNames[lang] || lang}
                className={`${S.tagChip} ${S.languageChip} ${selected ? S.selected : ""}`}
                role="switch"
                aria-checked={selected}
                tabIndex={0}
                onClick={() => handleLangClick(lang)}
                onKeyDown={e => handleKeyDown(e, () => handleLangClick(lang))}
              />
            );
          })}
        </div>
      </section>
    </div>
  );
};

export default TagBrowser;
